<script>
import options from "./NykCheckbox.options"
export default options
</script>

<template>
  <div class="nyk-checkbox nyk-form-element" :class="{ 'nyk-form-element--validation-failed': errorMessage }">
    <div class="nyk-checkbox-item">
      <div 
        class="nyk-checkbox-item__choice"
        role="checkbox">
        <input :ref="el => inputElement = el"
          :id="name"
          :name="name"
          type="checkbox"
          class="nyk-checkbox-item__choice__input"
          :aria-describedby="errorMessage ? `description-${name}-error` : `description-${name}`"
          :aria-invalid="!!errorMessage"
          :aria-required="required"
          :invalid="!!errorMessage"
          :checked="checkedState"
          :value="checkedState"
          v-bind="attributes"
          v-on="validationListeners"
          @input.stop="onInputChange"
          @select.prevent.stop
          @focus="onFocus"
          @blur.prevent.stop="onBlur" />

        <div class="nyk-checkbox-item__choice__square">
          <div class="nyk-checkbox-item__choice__square__outer"></div>
          <div class="nyk-checkbox-item__choice__square__inner"></div>
        </div>
      </div>
      <label
        :for="name"
        class="nyk-checkbox-item__label"
        v-html="label">
      </label>
    </div>
    <span class="nyk-form-element__help-message" :id="`description-${name}`">{{ description }}</span>
    <span v-if="errorMessage" class="nyk-form-element__error-message" :id="`description-${name}-error`" aria-live="polite">{{ errorMessage }}</span>
  </div>
</template>